import { isSupabaseConfigured } from "../supabase";
import { createLocalStorageInvoiceStore } from "./localStorageStore";
import { createSupabaseInvoiceStore } from "./supabaseStore";
import type { InvoiceStore } from "./types";

// Same pattern as `src/lib/expenses/index.ts`: pick the implementation at
// module import time. Playwright runs with VITE_E2E_BYPASS_AUTH=true, which
// forces the localStorage store so tests don't need a real Supabase project.
const useLocal =
  import.meta.env.VITE_E2E_BYPASS_AUTH === "true" || !isSupabaseConfigured;

export const invoiceStore: InvoiceStore = useLocal
  ? createLocalStorageInvoiceStore()
  : createSupabaseInvoiceStore();

export type {
  Invoice,
  InvoiceDirection,
  InvoiceStatus,
  InvoiceStore,
  NewInvoiceInput,
} from "./types";
